<ng-container>
    <ng-template #subItem let-item>
        <li [class.has-sub]="item.children && item.children.length > 0">
            <span class="submenu-button" *ngIf="item.children && item.children.length > 0"
                (click)="expandOrCollapse(item); $event.stopPropagation()" 
                [class.submenu-opened]="!item.collapsed"></span>

            <a [class.active]="isSideNavActive(item.link, item.originalLink)" [class.selectedLi]="isSideNavActive(item.link, item.originalLink)"
                (click)="navigate(item.link)" [ngStyle]="{'padding-left': ((item.level + 1) * 3) + 'rem'}">{{item.label}} </a>

            <ul *ngIf="item.children && item.children.length > 0" class="nav_menu" 
                [style.display]="!item.collapsed ? 'block' : 'none'">
                <ng-container *ngFor="let subChild of item.children">
                    <ng-container *ngTemplateOutlet="subItem; context: { $implicit: subChild }"></ng-container>
                </ng-container>
            </ul>
        </li>
    </ng-template>

    <ng-template #rootItem let-item>
        <li class="level0 has-sub" [class.active]="isActive(item.path)">
            <span class="submenu-button" (click)="expandOrCollapse(item); $event.stopPropagation()"
                [class.submenu-opened]="!item.collapsed"></span>
            <a [class.selectedLi]="isActive(item.path)" (click)="navigate(item.link)">
                {{item.data.label | uppercase}}
            </a>
            <ul class="nav_menu" [style.display]="!item.collapsed ? 'block' : 'none'">
                <ng-container *ngFor="let child of item.childNavs">
                    <ng-container *ngTemplateOutlet="subItem; context: { $implicit: child }"></ng-container>
                </ng-container>
            </ul>
        </li>
    </ng-template>

    <div id="menu" *ngIf="this.data.length > 0">
        <nav class="nav" id="multimenu">
            <div id="head-mobile"></div>
            <div class="button" (click)="collapseMobileNav()" [class.menu-opened]="showMobileNav"></div>

            <ul class="nav_menu" [class.nav_menu_full]="showMobileNav">
                <ng-container *ngIf="this.psuedoLoginInfo == null">
                    <ng-container *ngFor="let item of data">
                        <ng-container *ngTemplateOutlet="rootItem; context: {$implicit: item}"></ng-container>
                    </ng-container>

                    <li *ngIf="this.isRegMode" class="level0 has-sub">
                        <a style="cursor: pointer;" [class.active.selected]="isActive">{{this.regRole | uppercase}}</a>
                    </li>
                </ng-container>

                <ng-container *ngIf="this.psuedoLoginInfo != null">
                    <ng-container *ngFor="let item of this.psuedoLoginInfo.LoginNavs | keyvalue">
                        <li class="level0">
                            <a style="cursor: pointer;">{{item.value + " Login" | uppercase}}</a>
                        </li>
                    </ng-container>
                </ng-container>
            </ul>
        </nav>
    </div>
</ng-container>